import styled from 'styled-components';

import { colors } from '@crm-framework/theme';

export const UploadStatusContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const UploadReportWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UploadStatusHeader = styled.div`
  font-size: 18px;
  text-align: center;
  color: ${colors.N7};
`;

export const ProgressBarContainer = styled.div`
  width: 150px;
  height: 50%;
`;
